// .u_amo-member-directory-result
class UAMOMemberDirectoryResult extends Uneet {
  constructor (domElement, data) {
    super(domElement)
    this.__init(data)
  }

  __init (data) {
    this._e.innerHTML = this.__generateMarkup(data)
  }

  __generateMarkup (data) {
    data.photo_url = data.photo_url ? data.photo_url.trim() : '/content/themes/wx-theme/uneets/dist/assets/imgs/profile-pic-placeholder.png'
    const template = `
      <a href="${data.url}" class="img-container">
        <span class="img-hoverer">
          <img src="${data.photo_url}"/>
        </span>
      </a>
      <div class="info">
        ${(data.first_name || data.last_name) ?
          `<a href="${data.url ? `${data.url}` : '#'}" class="name">${data.first_name ? `${data.first_name}` : ''}  ${data.last_name ? `${data.last_name}` : ''}</a>`
        : ''}
        ${data.corporate_title ? `<span class="corporate-title">${data.corporate_title}</span>` : ''}
        ${data.functional_title ? `<span class="functional-title">${data.functional_title}</span>` : ''}
        ${data.company_name ? `<span class="company-name">${data.company_name}</span>` : ''}
        ${(data.committees.length > 0) ?
            `<div class="committees">
              ${data.committees.map(committee => `<span class="committee">${committee.name}</span>`).join(' ')}
            </div>`
          : ''
        }
        ${data.phone ? `<a href="tel:${data.phone}" class="phone">${data.phone}</a>` : ''}
        ${data.email ? `<a href="mailto:${data.email}" class="email">${data.email}</a>` : ''}
        ${(data.linkedin_url || data.facebook_url || data.twitter_url) ?
          ` <div class="social">
            ${data.linkedin_url ? `
              <a href="${data.linkedin_url}" class="linkedin">
                <span>go to LinkedIn Profile</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1536 1536">
                  <path d="M365,1414H596V720H365ZM611,506q-1-52-36-86t-93-34q-58,0-94.5,34T351,506q0,51,35.5,85.5T479,626h1q59,0,95-34.5T611,506Zm585,908h231V1016q0-154-73-233t-193-79q-136,0-209,117h2V720H723q3,66,0,694H954V1026q0-38,7-56a154.36,154.36,0,0,1,45-59.5q30-24.5,74-24.5,116,0,116,157Zm468-998v960q0,119-84.5,203.5T1376,1664H416q-119,0-203.5-84.5T128,1376V416q0-119,84.5-203.5T416,128h960q119,0,203.5,84.5T1664,416Z" transform="translate(-128 -128)"/>
                </svg>
              </a>
            ` : ''}
            ${data.facebook_url ? `
              <a href="${data.facebook_url}" class="linkedin">
                <span>go to Facebook Profile</span>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1792 1792" style="enable-background:new 0 0 1792 1792;" xml:space="preserve">
                  <path d="M1456,0c92.6,0,171.7,32.9,237.4,98.6S1792,243.4,1792,336v1120c0,92.6-32.9,171.7-98.6,237.4S1548.6,1792,1456,1792h-219.3 v-694.2h232.2l35-270.7h-267.2V654.5c0-43.6,9.1-76.2,27.4-98s53.9-32.7,106.8-32.7l142.3-1.2V281.2c-49-7-118.2-10.5-207.7-10.5 c-105.8,0-190.4,31.1-253.8,93.3s-95.1,150.1-95.1,263.7v199.5H723.3v270.7h233.3V1792H336c-92.6,0-171.7-32.9-237.4-98.6 S0,1548.6,0,1456V336c0-92.6,32.9-171.7,98.6-237.4S243.4,0,336,0H1456z"/>
                </svg>
              </a>
            ` : ''}
            ${data.twitter_url ? `
              <a href="${data.twitter_url}" class="linkedin">
                <span>go to Twitter Profile</span>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1792 1792" style="enable-background:new 0 0 1792 1792;" xml:space="preserve">
                  <path d="M1493.3,562.3c-43.6,19.4-90.6,32.7-141.2,39.7c52.9-31.1,89.1-76.6,108.5-136.5c-50.6,29.6-102.7,49.4-156.3,59.5c-47.4-51.3-106.9-77-178.5-77c-67.7,0-125.4,23.9-173.3,71.8c-47.8,47.8-71.8,105.6-71.8,173.2c0,22.6,1.9,41.2,5.8,56c-100.3-5.4-194.4-30.7-282.3-75.8s-162.6-105.4-224-180.8c-22.6,38.9-33.8,80.1-33.8,123.7c0,88.7,35.4,156.7,106.2,204.2c-36.6-0.8-75.4-10.9-116.7-30.3v2.3c0,58.3,19.4,110.2,58.3,155.8s86.7,73.7,143.5,84.6c-22.6,6.2-42.4,9.3-59.5,9.3
                    c-10.1,0-25.3-1.6-45.5-4.7c16.3,49,45.3,89.4,86.9,121.3s88.9,48.2,141.8,49c-90.2,70-191.7,105-304.5,105c-19.5,0-39-1.1-58.3-3.5
                    c115.1,73.1,240.3,109.7,375.7,109.7c87.1,0,168.8-13.8,245-41.4s141.6-64.6,196-110.8c54.4-46.2,101.7-100,140.6-159.8
                    c39.3-60.3,68.4-123.3,87.5-189c19.1-65.7,28.6-131.2,28.6-196.6c0.1-10.5-0.2-21-1.2-31.5C1419.2,655.1,1460.8,612,1493.3,562.3z
                     M1792,336v1120c0,92.6-32.9,171.7-98.6,237.4S1548.6,1792,1456,1792H336c-92.6,0-171.7-32.9-237.4-98.6S0,1548.6,0,1456V336
                    c0-92.6,32.9-171.7,98.6-237.4S243.4,0,336,0h1120c92.6,0,171.7,32.9,237.4,98.6S1792,243.4,1792,336z"/>
                </svg>
              </a>
            ` : ''}
          </div>` :
          ''
        }
      </div>
    `
    return template
  }
}
